import { USER_ROLE_OWNER, USER_ROLE_VIEWER } from '../../../../../constants/video';

export const TEAM_SHARE = 'TEAM_SHARE';
export const GUEST_SHARE = 'GUEST_SHARE';

export const REQUEST_SIZE_INTERNAL_SHARED_USERS = 20;
export const REQUEST_SIZE_EXTERNAL_SHARED_USERS = 20;

export const USER_ROLE_MAP_TITLE = {
  [USER_ROLE_OWNER]: 'Owner',
  [USER_ROLE_VIEWER]: 'Viewer',
};

export const TEAM_USER_STATE_ACTIVE = 1;
export const TEAM_USER_STATE_INACTIVE = 0;

export const GUEST_USER_STATE_IN_PROGRESS = 'IN_PROGRESS';
export const GUEST_USER_STATE_ACTIVE = 'ACTIVE';
export const GUEST_USER_STATE_PENDING = 'PENDING';
export const GUEST_USER_STATE_REVOKED = 'REVOKED';

export const GUEST_USER_STATE_MAP_TITLE = {
  [GUEST_USER_STATE_IN_PROGRESS]: 'In progress',
  [GUEST_USER_STATE_ACTIVE]: 'Guest',
  [GUEST_USER_STATE_PENDING]: 'Pending invitation',
};

export const SHARED_USER_ITEM_HEIGHT = 30;
export const SHARED_USER_ITEM_MAX_ROWS = 4;
